export { default } from './GainsightProvider';
export * from './GainsightProvider';
